// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"de471e09","627":"95720012","938":"a0c08b53","943":"8e2f7734"}[chunkId] + ".chunk.js";
};